// servizi/prova.ts — modalità di prova (tester): partita contro il bot, quota azzerata, opzioni di diagnostica.
import { richiesta } from "./api.ts";
import { idDispositivo } from "./dispositivo.ts";
import { leggiPreferenza, salvaPreferenza } from "./preferenze.ts";
import { PREFERENZE } from "../costanti.ts";

export function creaPartitaProva(nome: string): Promise<{ codice: string; token: string; link: string }> {
  return richiesta("/api/v1/prova/partita", { metodo: "POST", corpo: { nome, dispositivo: idDispositivo() } });
}
/** «Prova da solo» (v015): la partita contro il bot per tutti, anche senza account. */
export function creaProvaDaSolo(nome: string): Promise<{ codice: string; token: string; link: string }> {
  return richiesta("/api/v1/prova/da-solo", { metodo: "POST", corpo: { nome, dispositivo: idDispositivo() } });
}
export function azzeraQuota(): Promise<void> {
  return richiesta("/api/v1/prova/quota-azzera", { metodo: "POST" });
}

type Opzione = typeof PREFERENZE.provaDiagnostica | typeof PREFERENZE.provaSoloTurn;
export const opzioneProva = (k: Opzione): boolean => leggiPreferenza(k) === "si";
export const impostaOpzioneProva = (k: Opzione, v: boolean): void => salvaPreferenza(k, v ? "si" : "no");
